package core.io.dto

import kotlinx.serialization.SerialName

@kotlinx.serialization.Serializable
data class ExternalLinkDTO (
    @SerialName("url")
    val mUrl: String,
)